<template>
  <div class="sub-container">
    <div class="sub-container flex-sb">
      <div class="content col">
        <section class="section">
          <h3 class="section-title">신청 상세정보</h3>
          <table class="tbl-view app-detail-info input">
            <colgroup>
              <col class="head" />
              <col class="data" />
              <col class="head" />
              <col class="data" />
            </colgroup>
            <tbody>
              <tr>
                <th>신청항목</th>
                <td class="inp-data">
                  <div class="select-wrap relation">
                    <select
                      v-model="application.applicationItem"
                      @change="onApplicationItemChange"
                    >
                      <option value="의료비지원">의료비지원</option>
                      <option value="재외동포지원">재외동포지원</option>
                    </select>
                  </div>
                </td>
              </tr>
              <tr>
                <th>이름</th>
                <td class="inp-data">
                  <div class="flex-row">
                    <input
                      type="text"
                      class="inp-txt-common contact-name"
                      v-model="application.name"
                      placeholder="이름"
                    />
                    <span class="bar"></span>
                    <div class="select-wrap relation">
                      <select v-model="application.applicationRegistrationType">
                        <option value="본인">본인</option>
                        <option value="미성년자녀">미성년자녀</option>
                        <option value="기관">기관</option>
                      </select>
                    </div>
                  </div>
                </td>
                <th class="multi-line">주민번호<br />(외국인번호)</th>
                <td class="inp-data">
                  <div class="flex-row">
                    <input
                      type="text"
                      class="inp-txt-common id-num"
                      v-model="application.socialSecurityNumber"
                    />
                    <span class="bar"></span>
                    <div class="select-wrap relation">
                      <select v-model="application.nationality">
                        <option value="내국">내국인</option>
                        <option value="외국">외국인</option>
                      </select>
                    </div>
                    <span class="bar"></span>
                    <div class="select-wrap relation">
                      <select v-model="application.sex">
                        <option value="남">남성</option>
                        <option value="여">여성</option>
                      </select>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>휴대폰번호</th>
                <td class="inp-data">
                  <input
                    type="text"
                    class="inp-txt-common full"
                    v-model="application.mobile"
                  />
                </td>
                <th>이메일</th>
                <td class="inp-data">
                  <input
                    type="text"
                    class="inp-txt-common full"
                    v-model="application.email"
                  />
                </td>
              </tr>
              <tr>
                <th>주소</th>
                <td class="inp-data" colspan="3">
                  <div class="addr flex-row">
                    <input
                      type="text"
                      class="inp-txt-common post-num"
                      v-model="application.postcode"
                    />
                    <button
                      class="btn-outline btn-post"
                      @click="addressPopup = true"
                    >
                      <span class="txt">우편번호</span>
                    </button>
                    <input
                      type="text"
                      class="inp-txt-common full"
                      v-model="application.address1"
                    />
                    <input
                      type="text"
                      class="inp-txt-common full"
                      v-model="application.address2"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th class="multi-line">보호자<br />(연락처)</th>
                <td class="inp-data">
                  <div class="flex-row">
                    <input
                      type="text"
                      class="inp-txt-common contact-name"
                      v-model="application.protectorName"
                    />
                    <span class="bar"></span>
                    <input
                      type="text"
                      class="inp-txt-common full"
                      v-model="application.protectorMobile"
                    />
                  </div>
                </td>
                <th>신청자와 관계</th>
                <td class="inp-data">
                  <div class="select-wrap relation">
                    <select v-model="application.protectorRelationship">
                      <option value="부">부</option>
                      <option value="모">모</option>
                      <option value="배우자">배우자</option>
                      <option value="자녀">자녀</option>
                      <option value="기관">기관</option>
                    </select>
                  </div>
                </td>
              </tr>
              <tr>
                <th>보험유형</th>
                <td class="inp-data">
                  <div class="select-wrap insurance">
                    <select v-model="application.healthInsuranceType">
                      <option value="기초생활수급자">기초생활수급자</option>
                      <option value="의료급여 1종">의료급여 1종</option>
                      <option value="의료급여 2종">의료급여 2종</option>
                      <option value="차상위계층">차상위계층</option>
                      <option value="건강보험 가입자 (직장)">
                        건강보험 가입자 (직장)
                      </option>
                      <option value="건강보험 가입자 (지역)">
                        건강보험 가입자 (지역)
                      </option>
                      <option value="건강보험 가입자 (외국인)">
                        건강보험 가입자 (외국인)
                      </option>
                    </select>
                  </div>
                </td>
                <th>가족수 | 보험료</th>
                <td class="inp-data">
                  <div class="flex-row">
                    <div class="select-wrap relation">
                      <select v-model="application.familyCount">
                        <option value="1">1인</option>
                        <option value="2">2인</option>
                        <option value="3">3인</option>
                        <option value="4">4인</option>
                        <option value="5">5인</option>
                        <option value="6">6인</option>
                        <option value="7">7인</option>
                        <option value="8">8인</option>
                        <option value="9">9인</option>
                        <option value="10">10인</option>
                        <option value="11">11인</option>
                        <option value="12">12인</option>
                      </select>
                    </div>
                    <span class="bar"></span>
                    <comma-input
                      class="inp-txt-common ins-cost"
                      v-model="application.premium"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th>실비보험 소지여부</th>
                <td colspan="3">
                  <div class="t-radio-group">
                    <div class="radio">
                      <input
                        type="radio"
                        id="radio01"
                        name="radio"
                        value="있음"
                        v-model="application.lifeInsuranceExist"
                      />
                      <label for="radio01">있음</label>
                    </div>
                    <div class="radio">
                      <input
                        type="radio"
                        id="radio02"
                        name="radio"
                        value="없음"
                        v-model="application.lifeInsuranceExist"
                      />
                      <label for="radio02">없음</label>
                    </div>
                    <div class="radio">
                      <input
                        type="radio"
                        id="radio03"
                        name="radio"
                        value="치아실비있음"
                        v-model="application.lifeInsuranceExist"
                      />
                      <label for="radio03">치아실비있음</label>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>첨부서류</th>
                <td class="inp-data" colspan="3">
                  <div class="attach flex-row" style="margin-bottom: 10px">
                    <file-upload
                      title="주민등록등본"
                      button-title="서류첨부"
                      v-on:uploaded="changeDocument"
                      input-id="residentRegister"
                      :origin-url="application.document.residentRegister"
                    />
                    <span class="bar"></span>
                    <file-upload
                      title="건강보험납부확인서"
                      button-title="서류첨부"
                      v-on:uploaded="changeDocument"
                      input-id="healthInsurancePayments"
                      :origin-url="application.document.healthInsurancePayments"
                    />
                  </div>
                  <div class="attach flex-row" style="margin-bottom: 10px">
                    <file-upload
                      title="보험자주민등록등본"
                      button-title="서류첨부"
                      v-on:uploaded="changeDocument"
                      input-id="insurerResidentRegister"
                      :origin-url="application.document.insurerResidentRegister"
                    />
                    <span class="bar"></span>
                    <file-upload
                      title="가족관계증명서"
                      button-title="서류첨부"
                      v-on:uploaded="changeDocument"
                      input-id="familyRelationsCertificate"
                      :origin-url="
                        application.document.familyRelationsCertificate
                      "
                    />
                  </div>
                  <div class="attach flex-row" style="margin-bottom: 10px">
                    <file-upload
                      title="건강보험자격확인서"
                      button-title="서류첨부"
                      v-on:uploaded="changeDocument"
                      input-id="healthInsuranceCertificate"
                      :origin-url="
                        application.document.healthInsuranceCertificate
                      "
                    />
                    <span class="bar"></span>
                    <file-upload
                      title="기초연금수급자확인서"
                      button-title="서류첨부"
                      v-on:uploaded="changeDocument"
                      input-id="oldAgePensionerCertificate"
                      :origin-url="
                        application.document.oldAgePensionerCertificate
                      "
                    />
                  </div>
                  <div class="attach flex-row" style="margin-bottom: 10px">
                    <file-upload
                      title="기초생활수급자확인서"
                      button-title="서류첨부"
                      v-on:uploaded="changeDocument"
                      input-id="basicLivelihoodCertificate"
                      :origin-url="
                        application.document.basicLivelihoodCertificate
                      "
                    />
                    <span class="bar"></span>
                    <file-upload
                      title="차상위 계층 증명서"
                      button-title="서류첨부"
                      v-on:uploaded="changeDocument"
                      input-id="secondClassCertificate"
                      :origin-url="application.document.secondClassCertificate"
                    />
                  </div>
                  <div class="attach flex-row" style="margin-bottom: 10px">
                    <file-upload
                      title="여권"
                      button-title="서류첨부"
                      v-on:uploaded="changeDocument"
                      input-id="passport"
                      :origin-url="application.document.passport"
                    />
                    <span class="bar"></span>
                    <file-upload
                      title="외국인등록 사실증명서"
                      button-title="서류첨부"
                      v-on:uploaded="changeDocument"
                      input-id="alienRegistrationCertificate"
                      :origin-url="
                        application.document.alienRegistrationCertificate
                      "
                    />
                  </div>
                  <div class="attach flex-row" style="margin-bottom: 10px">
                    <file-upload
                      title="소득금액증명원"
                      button-title="서류첨부"
                      v-on:uploaded="changeDocument"
                      input-id="incomeAmountCertificate"
                      :origin-url="application.document.incomeAmountCertificate"
                    />
                    <span class="bar"></span>
                    <file-upload
                      title="추가서류"
                      button-title="서류첨부"
                      v-on:uploaded="changeDocument"
                      input-id="etc"
                      :origin-url="application.document.etc"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th class="multi-line">신청병원<br />진료과목</th>
                <td class="inp-data">
                  <div class="flex-row">
                    <div class="select-wrap major">
                      <input
                        type="text"
                        class="inp-txt-common full"
                        :value="application.treatmentSubject"
                        readonly
                      />
                    </div>
                    <div class="select-wrap major">
                      <input
                        type="text"
                        class="inp-txt-common full"
                        :value="hospitalName"
                        readonly
                      />
                    </div>
                  </div>
                </td>
                <th>지원항목</th>
                <td class="inp-data">
                  <div class="select-wrap full">
                    <select v-model="application.medicalCare">
                      <option
                        v-for="(care, index) in medicalCareList"
                        v-bind:key="index"
                        :value="care.careName"
                      >
                        {{ care.careName }}
                      </option>
                    </select>
                  </div>
                </td>
              </tr>
              <tr>
                <th>치료내용</th>
                <td class="inp-data" colspan="3">
                  <textarea
                    class="text-area"
                    v-model="application.treatmentDetails"
                    placeholder="치료내용을 입력해주세요"
                  ></textarea>
                </td>
              </tr>
              <tr>
                <th>총비용</th>
                <td class="inp-data">
                  <comma-input
                    class="inp-txt-common full"
                    v-model="application.totalAmount"
                    placeholder="총비용"
                  />
                </td>
                <th>지원비용</th>
                <td class="inp-data">
                  <comma-input
                    class="inp-txt-common full"
                    v-model="application.supportAmount"
                    placeholder="지원비용"
                  />
                </td>
              </tr>
              <tr>
                <th>자기부담금</th>
                <td class="inp-data" colspan="3">
                  <comma-input
                    class="inp-txt-common full"
                    v-model="application.selfAmount"
                    placeholder="자기부담금"
                  />
                </td>
              </tr>
              <tr>
                <th>병원측 메모</th>
                <td class="inp-data" colspan="3">
                  <textarea
                    class="text-area"
                    v-model="application.hospitalMemo"
                    placeholder="병원측 메모를 입력해주세요"
                  ></textarea>
                </td>
              </tr>

              <tr>
                <th>생활환경 및 사연</th>
                <td class="inp-data" colspan="3">
                  <div class="flex-row">
                    <textarea
                      class="text-area"
                      v-model="application.story"
                      @input="autoResizeTextarea"
                      ref="storyTextarea"
                      placeholder="생활환경 및 사연을 입력해주세요"
                    ></textarea>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="table-detail-foot flex-se">
            <button class="btn-outline tf-inp-btn" @click="cancel">
              <span class="txt">취소</span>
            </button>
            <button class="btn-confirm tf-inp-btn" @click="add">
              <span class="txt ico apply-w">등록하기</span>
            </button>
          </div>
          <div class="view-tail">
            <button class="btn-go-list" @click="cancel">
              <span class="txt go-list">목록으로</span>
            </button>
          </div>
        </section>
      </div>
      <div class="content col"></div>
    </div>
    <div class="address-popup" v-if="addressPopup">
      <KakaoPostcode
        :on-complete="handleAddress"
        @close="addressPopup = false"
      />
    </div>
  </div>
</template>
<style></style>
<script>
import KakaoPostcode from "@/components/KakaoPostcode.vue";
import FileUpload from "../components/FileUpload";
import CommaInput from "@/components/CommaInput.vue";
import { formatAreaFromPostcode } from "@/utils/area";
export default {
  name: "ApplicationAdd",
  components: { CommaInput, KakaoPostcode, FileUpload },
  data: () => ({
    application: {
      applicationItem: "의료비지원",
      applicationRegistrationType: "본인",
      treatmentDetails: "",
      totalAmount: "",
      supportAmount: "",
      selfAmount: "",
      hospitalMemo: "",
      hospitalId: null,
      treatmentSubject: "",
      medicalCare: "",
      document: {
        residentRegister: "",
        healthInsurancePayments: "",
        insurerResidentRegister: "",
        familyRelationsCertificate: "",
        healthInsuranceCertificate: "",
        oldAgePensionerCertificate: "",
        basicLivelihoodCertificate: "",
        secondClassCertificate: "",
        passport: "",
        alienRegistrationCertificate: "",
        incomeAmountCertificate: "",
        etc: "",
        alienRegistrationCard: "",
        recommendationLetter: ""
      }
    },
    hospital: null,
    hospitalName: "",
    medicalCareList: [],
    addressPopup: false
  }),
  mounted() {
    this.$nextTick(() => {
      this.initAutoResize();
    });
  },
  beforeMount() {
    this.loadHospital();
  },
  methods: {
    autoResizeTextarea(event) {
      const textarea = event.target;
      textarea.style.height = "auto";
      textarea.style.height = Math.max(textarea.scrollHeight, 100) + "px";
    },
    initAutoResize() {
      this.$nextTick(() => {
        if (this.$refs.storyTextarea) {
          this.$refs.storyTextarea.style.height = "auto";
          this.$refs.storyTextarea.style.height =
            Math.max(this.$refs.storyTextarea.scrollHeight, 100) + "px";
        }
      });
    },
    async loadHospital() {
      try {
        const response = await this.$axios.get("hospital/hospital-info");
        if (response.data.success || response.data.data) {
          this.hospital = response.data.data;
          this.hospitalName = this.hospital.hospitalName || "";
          this.application.hospitalId = this.hospital.hospitalId;
          this.application.treatmentSubject =
            this.hospital.treatmentSubject || "";
          this.updateMedicalCareList();
        }
      } catch (ex) {
        console.error(ex);
        this.$alert.show("병원 정보를 불러오지 못했습니다.");
      }
    },
    updateMedicalCareList() {
      if (!this.hospital) {
        this.medicalCareList = [];
        return;
      }
      if (this.application.applicationItem === "의료비지원") {
        this.medicalCareList = this.hospital.domesticMedicalCareList || [];
      } else {
        this.medicalCareList = this.hospital.overseaMedicalCareList || [];
      }
      if (
        this.medicalCareList.length > 0 &&
        !this.medicalCareList.find(
          c => c.careName === this.application.medicalCare
        )
      ) {
        this.application.medicalCare = this.medicalCareList[0].careName;
      }
    },
    onApplicationItemChange() {
      this.updateMedicalCareList();
    },
    cancel() {
      this.$router.push({
        path: "/applications"
      });
    },
    handleAddress(data) {
      this.application.address1 = data.roadAddress;
      this.application.area = formatAreaFromPostcode(data);
      this.application.postcode = data.zonecode;
      this.addressPopup = false;
    },
    changeDocument(document) {
      this.application.document[document.id] = document.url;
    },
    async add() {
      if (!this.application.hospitalId) {
        this.$alert.show("병원 정보가 없습니다. 다시 로그인해주세요.");
        return;
      }
      if (!this.application.applicationItem) {
        this.$alert.show("신청항목을 선택해주세요");
        return;
      }
      if (!this.application.treatmentSubject) {
        this.$alert.show("진료과목 정보가 없습니다.");
        return;
      }
      if (!this.application.medicalCare) {
        this.$alert.show("지원항목을 선택해주세요");
        return;
      }

      var param = this.application;

      this.$axios
        .post("hospital/hospital-application", param)
        .then(response => {
          if (response.data.success) {
            this.$alert.show(response.data.message);
            this.$router.push({
              path: "/application/" + response.data.data.applicationId
            });
          } else {
            this.$alert.show(response.data.message);
          }
        })
        .catch(ex => {
          if (
            ex.response &&
            ex.response.data &&
            ex.response.data.message &&
            ex.response.data.message.constructor == Object
          ) {
            this.$alert.show(ex.response.data.message);
          } else if (ex.response && ex.response.data && ex.response.data.message) {
            this.$alert.show(ex.response.data.message);
          } else {
            this.$alert.show("신청서 등록에 실패했습니다.");
          }
        });
    }
  }
};
</script>
